import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Typography from "material-ui-next/Typography";
import { Loadable, DescriptionField } from "components/support";

export default class WebhooksView extends Component {
  render() {
    const { viewModel } = this.props;
    const { loading, webhooks } = viewModel;

    return (
      <div className="grid-container mt-sm mb-sm">
        <Row>
          <Col xs={12}>
            <Loadable loading={loading}>
              <Typography type="headline">Webhooks</Typography>

              {webhooks.map(hook => (
                <DescriptionField key={hook.uuid} value={hook.endpoint} />
              ))}
            </Loadable>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/company/view/integrations/webhooks/view.jsx